// Generic node/edge shape consumed by GraphCanvasOntology, kept local to the ontology
// module so it has no dependency on the knowledge-library module.
export const NodeType = {
  ASSET: "ASSET",
  SYSTEM: "SYSTEM",
  SUBSYSTEM: "SUBSYSTEM",
  EQUIPMENT: "EQUIPMENT",
  REQUIREMENT: "REQUIREMENT",
  DISCIPLINE: "DISCIPLINE",
  DOCUMENT: "DOCUMENT",
  COMPONENT: "COMPONENT",
  SENSOR: "SENSOR"
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type NodeType = (typeof NodeType)[keyof typeof NodeType] | string;

export type GraphNode = {
  id: string;
  label: string;
  type: NodeType;
  x: number;
  y: number;
};

export type GraphEdge = {
  id: string;
  source: string;
  target: string;
  relationship: string;
};
